export class ValidationInputData {
    validationConfigurationId: number;
    ticketNumber: string;
    validationAddInfo: string;
}
